import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { FormSubmission, FormSyncChannel } from './types';

const postAction = async (
  id: string,
  action: 'retry' | 'skip',
  channel?: FormSyncChannel,
) => {
  const response = await baseAPI.post<FormSubmission>(
    `forms/submissions/${id}/${action}`,
    channel ? { channel } : {},
  );
  return response.data;
};

const useSubmissionAction = (action: 'retry' | 'skip') => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, channel }: { id: string; channel?: FormSyncChannel }) =>
      postAction(id, action, channel),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FORM_SUBMISSIONS],
      });
    },
  });
};

export const useRetryFormSubmission = () => useSubmissionAction('retry');
export const useSkipFormSubmission = () => useSubmissionAction('skip');
